import { render, staticRenderFns } from "./perquisites.vue?vue&type=template&id=77d7aac9&scoped=true"
import script from "./perquisites.vue?vue&type=script&lang=js"
export * from "./perquisites.vue?vue&type=script&lang=js"
import style0 from "./perquisites.vue?vue&type=style&index=0&id=77d7aac9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d7aac9",
  null
  
)

export default component.exports